module.exports = __webpack_public_path__ + "img/video-download-offline.89a7bce5.svg";